import { el , appendAll} from './layout';

export type Column<T> = {
  key: string;
  label: string;
  sortable?: boolean;
  render: (row: T) => Node | string;
};

export function dataTable<T>(opts: {
  columns: Column<T>[];
  rows: T[];
  sortKey?: string;
  sortDir?: 'asc' | 'desc';
  onSort?: (key: string) => void;
  rowClass?: (row: T) => string;
  onRowClick?: (row: T, ev: MouseEvent) => void;
}): HTMLElement {
  const wrap = el('div', { className: 'table-wrap' });
  const table = el('table', { className: 'data' });
  const thead = el('thead');
  const hr = el('tr');
  for (const col of opts.columns) {
    const th = el('th', {
      className: col.sortable ? 'sortable' : '',
      text:
        col.label +
        (opts.sortKey === col.key ? (opts.sortDir === 'asc' ? ' ↑' : ' ↓') : ''),
    });
    if (col.sortable && opts.onSort) {
      th.addEventListener('click', () => opts.onSort?.(col.key));
    }
    hr.appendChild(th);
  }
  thead.appendChild(hr);
  const tbody = el('tbody');
  if (!opts.rows.length) {
    appendAll(tbody, el('tr', {}, [
        el('td', {
          colspan: String(opts.columns.length),
          className: 'muted',
          text: 'No rows',
        }),
      ]),
    );
  } else {
    for (const row of opts.rows) {
      const tr = el('tr', {
        className: opts.rowClass?.(row) || '',
      });
      if (opts.onRowClick) {
        tr.addEventListener('click', (ev) => opts.onRowClick?.(row, ev));
      }
      for (const col of opts.columns) {
        const td = el('td');
        const cell = col.render(row);
        if (typeof cell === 'string') td.textContent = cell;
        else td.appendChild(cell);
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    }
  }
  appendAll(table, thead, tbody);
  wrap.appendChild(table);
  return wrap;
}
